import { formatPrice } from "@/data/menu";

// Compact scannable drink line: NAME  volume · flavors ............ price
export const DrinkRow = ({ product }) => {
  const price = formatPrice(product.price);
  const meta = product.volume || product.weight;
  return (
    <li className="flex items-start gap-3 py-3">
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5">
          <span className="font-bold text-roty-ink">{product.name}</span>
          {meta ? (
            <span className="text-sm font-medium text-roty-ash">{meta}</span>
          ) : null}
        </div>
        {product.flavors ? (
          <div className="mt-0.5 text-xs leading-snug text-roty-ash/90">{product.flavors}</div>
        ) : null}
      </div>
      {price ? (
        <span className="shrink-0 whitespace-nowrap font-extrabold tabular-nums text-roty-red">
          {price}
        </span>
      ) : null}
    </li>
  );
};
